declare type useDeviceType = 'phone' | 'desktop'

export const useDeviceType = () => {
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        return 'phone'
    } else {
        return 'desktop'
    }
}